import { useEffect, useState } from "react";
import { getMagentoImage, mapSizeLabel } from "../utils";

function CartReview({ item, onBack, onCheckout, onUpdateItem }) {
  const [isPersonalizationConfirmed, setIsPersonalizationConfirmed] =
    useState(false);
  const personalizationValue = item?.optionValue || "";
  const hasPersonalizationValue = Boolean(personalizationValue.trim());

  useEffect(() => {
    setIsPersonalizationConfirmed(false);
  }, [personalizationValue]);

  if (!item) return null;

  const image = item.product?.media_gallery_entries?.[0]?.file;
  const sizeLabel = mapSizeLabel(item.selectedSize);

  return (
    <div className="cart-review">
      <h2>Your Cart</h2>

      <div className="cart-card">
        <img src={getMagentoImage(image)} alt={item.product.name} />

        <p><strong>Product: </strong>{item.product.name}</p>

        <p><strong>Size:</strong> {sizeLabel}</p>

        {item.optionId && (
          <div className="personalization-field">
            <label htmlFor="personalization-input">
              Personalization Name
            </label>

            <p className="personalization-help">
              Enter the name exactly as it should appear on the jacket.
            </p>

            <input
              id="personalization-input"
              type="text"
              value={personalizationValue}
              onChange={(e) =>
                onUpdateItem({
                  ...item,
                  optionValue: e.target.value
                })
              }
              placeholder="Enter personalization name (optional)"
            />

            <label className="personalization-confirmation">
              <input
                type="checkbox"
                checked={isPersonalizationConfirmed}
                onChange={(e) =>
                  setIsPersonalizationConfirmed(e.target.checked)
                }
                disabled={!hasPersonalizationValue}
              />

              <span>
                I confirm the spelling is correct and understand this made-to-order item is non-returnable.
              </span>
            </label>
          </div>
        )}
      </div>

      <div className="cart-actions">
        <button onClick={onBack}>
          Change Product
        </button>

        <button
          onClick={() => onCheckout(item)}
          disabled={
            Boolean(item.optionId) &&
            hasPersonalizationValue &&
            !isPersonalizationConfirmed
          }
        >
          Continue to Checkout
        </button>
      </div>
    </div>
  );
}

export default CartReview;
